module.exports = __webpack_public_path__ + "static/img/ai-scan.f32c415d.png";